<div class="wrapper-video">
    <video autoplay (ended)="finish()">
        <source src="https://hai-public.s3.amazonaws.com/VideoEncerramento.mp4" type="video/mp4" />
    </video>
</div>
